import { companies } from "../../data/companies";
import CompanyCard from "./CompanyCard";
import styles from "./Companies.module.css";

export default function Companies() {
  return (
    <section id="companies" className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.sectionHeader}>
          <p className={styles.label}>Partners</p>
          <h2 className={styles.title}>EIE Partners & Ventures</h2>
          <p className={styles.subtitle}>
            A network of partners and companies that support EIE's mission to
            build smarter, more sustainable educational systems across the
            region.
          </p>
        </div>
        <div className={styles.grid}>
          {companies.map((company) => (
            <CompanyCard key={company.id} company={company} />
          ))}
        </div>
      </div>
    </section>
  );
}
